import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AdminVacante {
  idVacante: number;
  urlVacante: string;
  nombre: string;
  empresa: string;
  scrapeFuente: string | null;
  status: boolean;
  createdAt: string;
  totalPostulaciones: number;
  categoriaNombre: string | null;
}

export interface AdminPostulante {
  idPostulacion: number;
  nombre: string;
  correo: string;
  telefono: string;
  ciudad: string;
  fechaPostulacion: string;
  estatus: string;
}

export interface AdminPage {
  content: AdminVacante[];
  totalElements: number;
  totalPages: number;
  page: number;
  size: number;
}

export interface AdminFiltros {
  buscar?: string;
  empresa?: string;
  fuente?: string;
  estado?: string;
  desde?: string;
  hasta?: string;
  sortBy?: string;
  sortDir?: string;
}

@Injectable({ providedIn: 'root' })
export class AdminVacantesService {
  private base = `${environment.baseApi}/privado/admin/vacantes`;

  constructor(private http: HttpClient) {}

  listarVacantes(filtros: AdminFiltros, page: number, size: number): Observable<AdminPage> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);
    Object.entries(filtros).forEach(([k, v]) => {
      if (v != null && v !== '') params = params.set(k, v);
    });
    return this.http.get<AdminPage>(this.base, { params });
  }

  listarPostulantes(idVacante: number): Observable<AdminPostulante[]> {
    return this.http.get<AdminPostulante[]>(`${this.base}/${idVacante}/postulaciones`);
  }

  exportarExcel(filtros: AdminFiltros): Observable<Blob> {
    let params = new HttpParams();
    Object.entries(filtros).forEach(([k, v]) => {
      if (v != null && v !== '') params = params.set(k, v);
    });
    return this.http.get(`${this.base}/exportar`, { params, responseType: 'blob' });
  }
}
